import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const setCookies = (name, value, expiryAfterMinutes = 86400) => {
  const expire = new Date();
  expire.setMinutes(expire.getMinutes() + expiryAfterMinutes);

  try {
    if (name === process.env.REACT_APP_USERTOKEN_COOKIE_NAME && process.env.REACT_APP_ORION_ENV !== 'development') {
      cookies.set(name, value, { expires: expire, path: '/', secure: true });
    } else {
      cookies.set(name, value, { expires: expire, path: '/' });
      console.log(`${name} value is ${value}`);
    }
  } catch (err) {
    console.log(`Error setting cookie ${name} - value is ${value} --> ${err}`);
  }
};

export const getCookies = name => cookies.get(name);

export const removeCookies = (name, options = { path: '/' }) => cookies.remove(name, options);
